import {
    FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST,
    FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS,
    FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE
  } from '../actions/currentYearUIDTypes';
  
  const initialState = {
    loading: false,
    uids: [],
    error: '',
  };
  
  export const currentYearUIDReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST:
        return { ...state, loading: true };
      case FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS:
        return { loading: false, uids: action.payload, error: '' };
      case FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE:
        return { loading: false, uids: [], error: action.error };
      default:
        return state;
    }
  };
  